import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listColors } from '../Api'

export default generateApiAction({
  baseType: Types.COLORS.LIST,
  api: listColors,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/colors/ListAction.js